import { render, staticRenderFns } from "./animalAgedataitem.vue?vue&type=template&id=42e19bc5"
import script from "./animalAgedataitem.vue?vue&type=script&lang=js"
export * from "./animalAgedataitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports